const cleanTitle = (el) => {
  if (el.querySelector(".loop-title__name"))
    return;
  const cleaned = el.textContent.replace(/\s*\bPortion\b(?=\s*-)/i, "").trim();
  const dashIndex = cleaned.indexOf(" - ");
  const nameSpan = document.createElement("span");
  nameSpan.className = "loop-title__name block type__heading color__link";
  el.textContent = "";
  if (dashIndex !== -1) {
    nameSpan.textContent = cleaned.slice(0, dashIndex);
    const quantitySpan = document.createElement("span");
    quantitySpan.className = "loop-title__quantity block type-style__sn-title";
    quantitySpan.textContent = cleaned.slice(dashIndex + 3);
    el.appendChild(nameSpan);
    el.appendChild(quantitySpan);
  } else {
    nameSpan.textContent = cleaned;
    el.appendChild(nameSpan);
  }
};
const processNodes = (node) => {
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return;
  }
  if (node.matches(".loop-bundle-product-card-title")) {
    cleanTitle(node);
  }
  node.querySelectorAll(".loop-bundle-product-card-title").forEach((el) => {
    cleanTitle(el);
  });
};
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.target.nodeType === Node.ELEMENT_NODE && mutation.target.matches(".loop-bundle-product-card-title")) {
      cleanTitle(mutation.target);
    }
    mutation.addedNodes.forEach(processNodes);
  }
});
const target = document.getElementById("loop");
if (target) {
  processNodes(target);
  observer.observe(target, { childList: true, subtree: true });
}
